import { useCallback, useEffect, useState } from 'react';
import { authHeaders } from '../listPageStyles';
import { StatusBadge } from '../ui';
// NOT: canResend/canQueryGib/canCancel/hasResponse helper'ları BİLEREK import EDİLMEDİ —
// aksiyonların aktif/soluk durumu SUNUCUDAN gelir (`detail.actions`). Aynı kuralın iki kopyasını
// tutmak, zamanla ayrışmalarına ve ekranın "yapabilirsin" dediği bir işi backend'in reddetmesine
// yol açardı. Kapı backend'dedir; ekran onun kararını GÖSTERİR.
import {
  DOC_TYPE_LABEL, SCENARIO_LABEL, SOURCE_TYPE_LABEL,
  EVENT_AXIS, EVENT_AXIS_LABEL,
  RESPONSE, GIB, TRANSMISSION, ARCHIVE_REPORT,
  deriveOverallStatus, remainingDays, isApplicable, expectsResponse,
  needsResendWarning,
  fmtDateTime, fmtMoney,
} from './eDocumentModel';
import './eDocument.css';

const API_BASE = '/api/edocuments';

/**
 * FAZ 6 — Belge detayı: SLIDE-OVER DRAWER (spec §6.4/§6.5).
 *
 * ══ SEÇİM ≠ DETAY (İŞ KURALI 8) ═══════════════════════════════════════════════════════════════
 * Bu panel KENDİLİĞİNDEN AÇILMAZ. Satıra tıklamak onu AÇMAZ — checkbox'lar TOPLU AKSİYON içindir
 * (0–N satır), detay ise TAM OLARAK BİR belge gösterir. İkisini birbirine bağlamak, çoklu seçimde
 * "hangi belgenin detayı açılacak?" sorusunu cevapsız bırakırdı.
 * Açılış YALNIZ: satır sonundaki `İncele` ikonu VEYA araç çubuğundaki `İncele` (tam 1 seçimde).
 *
 * ══ AÇIKKEN GRID GÖRÜNÜR KALIR ════════════════════════════════════════════════════════════════
 * Modal DEĞİL, sağdan açılan bir panel. Kullanıcı bir belgeyi incelerken listeyi kaybetmez —
 * "bir sonrakine bakayım" demek için paneli kapatıp yeniden aramak zorunda kalmaz.
 * `✕` ve `Esc` kapatır.
 */
export function EDocumentDrawer({ open, documentId, onClose, onActionDone, showToast }) {
  const [detail, setDetail] = useState(null);
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [busy, setBusy] = useState(false);

  // Esc ile kapat (spec §6.4). Panel açıkken global dinleyici — modal'ın odak hapsi YOK,
  // çünkü kullanıcının arkadaki grid'e bakması BEKLENEN bir davranıştır.
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  const load = useCallback(async () => {
    if (!documentId) return;
    setLoading(true);
    try {
      const [dRes, eRes] = await Promise.all([
        fetch(`${API_BASE}/${documentId}`, { headers: authHeaders() }),
        fetch(`${API_BASE}/${documentId}/events`, { headers: authHeaders() }),
      ]);
      if (!dRes.ok) throw new Error('Belge detayı alınamadı');
      const dBody = await dRes.json();
      setDetail(dBody?.data ?? dBody?.Data ?? null);

      if (eRes.ok) {
        const eBody = await eRes.json();
        setEvents(eBody?.data ?? eBody?.Data ?? []);
      } else {
        setEvents([]);
      }
    } catch (err) {
      showToast?.('error', err.message || 'Detay yüklenemedi');
      setDetail(null);
      setEvents([]);
    } finally {
      setLoading(false);
    }
  }, [documentId, showToast]);

  useEffect(() => { if (open && documentId) load(); }, [open, documentId, load]);

  const post = async (path, successMsg) => {
    setBusy(true);
    try {
      const res = await fetch(`${API_BASE}/${documentId}/${path}`, {
        method: 'POST', headers: authHeaders(),
      });
      const body = await res.json().catch(() => null);
      if (!res.ok) throw new Error(body?.message || body?.Message || 'İşlem başarısız');

      const payload = body?.data ?? body?.Data ?? {};
      // Zarf hatasında tekrar gönderim yapıldıysa sunucu UYARIYI da döner — kullanıcı "kuyruğa
      // alındı" mesajını görüp belgeyi düzeltmeyi unutmasın diye uyarıyı ÖNE ÇIKARIYORUZ.
      showToast?.(payload.resendWarning ? 'info' : 'success', payload.message || successMsg);

      await load();
      onActionDone?.();
    } catch (err) {
      showToast?.('error', err.message || 'İşlem başarısız');
    } finally {
      setBusy(false);
    }
  };

  if (!open) return null;

  const row = detail?.document;
  const actions = detail?.actions ?? {};
  const overall = row ? deriveOverallStatus(row) : null;
  const remaining = row ? remainingDays(row) : null;

  return (
    <aside className="edoc-drawer" role="dialog" aria-label="Belge Detayı">
      <div className="edoc-drawer-head">
        <strong style={{ flex: 1, fontSize: 13 }}>Belge Detayı</strong>
        <button type="button" className="edoc-x" onClick={onClose} aria-label="Kapat">✕</button>
      </div>

      <div className="edoc-drawer-body">
        {loading && <div className="edoc-muted">Yükleniyor…</div>}

        {!loading && !row && <div className="edoc-muted">Belge bulunamadı.</div>}

        {!loading && row && (
          <>
            {/* ── 1. BELGE KÜNYESİ ─────────────────────────────────────────────────────── */}
            <div className="edoc-card">
              <div className="edoc-card-title-row">
                <div>
                  <div className="edoc-mono edoc-title">{row.documentNo || '(belge no yok)'}</div>
                  <div className="edoc-sub">
                    {DOC_TYPE_LABEL[row.documentType] || '—'}
                    {/* Senaryo YALNIZ e-Faturada vardır; e-Arşiv/e-İrsaliyede gösterilmez. */}
                    {isApplicable('scenario', row.documentType, row.scenario) && row.scenario != null
                      && ` · ${SCENARIO_LABEL[row.scenario]} senaryo`}
                  </div>
                </div>
                {overall && <StatusBadge tone={overall.tone}>{overall.label}</StatusBadge>}
              </div>

              <div style={{ height: 8 }} />
              <Kv label="ETTN" value={row.ettn
                ? <span className="edoc-mono">{row.ettn}</span>
                : <span className="edoc-na">henüz oluşmadı</span>} />
              <Kv label="Matbu no" value={row.printedNo || '—'} />
              <Kv label="Hareket tipi" value={SOURCE_TYPE_LABEL[row.sourceType] || '—'} />
              <Kv label="Plasiyer" value={detail.representativeName || '—'} />
              <Kv
                label="Alıcı"
                value={
                  <>
                    {detail.customerName || detail.vendorName || '—'}
                    {row.taxNumber
                      ? <span className="edoc-mono"> · {row.taxNumber}</span>
                      // Satıcıya iade faturasında Vendor'da VKN ALANI YOK (backend notu) →
                      // boş kalır. Sessizce boş bırakmak yerine SEBEBİNİ söylüyoruz: eksik VKN,
                      // zarf hatasının en sık sebebidir ve kullanıcı bunu bilmeli.
                      : <span className="edoc-na"> · VKN yok</span>}
                  </>
                }
              />
              <Kv label="Net tutar" value={<strong>{fmtMoney(row.netAmount)}</strong>} />
              <Kv label="Düzenlenme" value={fmtDateTime(row.issuedAt)} />
              <Kv label="Backoffice'e ulaştı" value={fmtDateTime(row.receivedAt)} />
            </div>

            {/* ── 2. YAŞAM DÖNGÜSÜ ZAMAN ÇİZELGESİ ─────────────────────────────────────── */}
            {/* Durum alanları belgenin ŞU ANKİ hâlini söyler; buradaki soru "NEREDE ve NE ZAMAN
                takıldı"dır. 3. denemede düzelen bir belgede son hata silinir — ama ilk iki
                denemenin neden battığı, hatanın tekrar edip etmediğini anlamanın tek yoludur. */}
            <div className="edoc-card">
              <div className="edoc-card-label">Yaşam Döngüsü</div>
              {events.length === 0 && <div className="edoc-muted">Henüz olay yok.</div>}
              {events.map((ev) => (
                <Timeline key={ev.id} ev={ev} />
              ))}

              {/* Henüz ULAŞILMAMIŞ adımlar soluk gösterilir: kullanıcı sürecin nerede DURDUĞUNU
                  değil, nereye KADAR GELDİĞİNİ de görmeli. */}
              {row.gibStatus === GIB.NOT_SENT && (
                <div className="edoc-tl edoc-tl--idle">
                  <span className="edoc-tl-dot">○</span>
                  <div>
                    <div>GİB zarfı</div>
                    <div className="edoc-tl-meta">servise ulaşmadan oluşmaz</div>
                  </div>
                </div>
              )}
              {!expectsResponse(row.documentType, row.scenario) && (
                <div className="edoc-tl edoc-tl--idle">
                  <span className="edoc-tl-dot">○</span>
                  <div>
                    <div>Karşı taraf yanıtı</div>
                    <div className="edoc-tl-meta">
                      {row.documentType === 2
                        ? 'e-Arşiv — alıcı mükellef değil, yanıt uygulanamaz'
                        : 'temel senaryo — yanıt uygulanamaz'}
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* ── 3. GİB / ENTEGRATÖR BLOĞU ────────────────────────────────────────────── */}
            <div className="edoc-card">
              <div className="edoc-card-label">GİB / Entegratör</div>
              <Kv label="Entegratör" value={row.integrator || <span className="edoc-na">yapılandırılmamış</span>} />
              <Kv label="Zarf UUID" value={row.envelopeUuid
                ? <span className="edoc-mono">{row.envelopeUuid}</span>
                : <span className="edoc-na">oluşmadı</span>} />
              <Kv label="Zarf durum kodu" value={row.envelopeStatusCode
                ? <span className={`edoc-mono ${row.gibStatus === GIB.ENVELOPE_ERROR ? 'edoc-danger' : 'edoc-ok'}`}>
                    {row.envelopeStatusCode}
                  </span>
                : <span className="edoc-na">—</span>} />
              {/* Otomatik ve manuel deneme AYRI GÖSTERİLİR (spec §11.7): "5 deneme" gördüğünde
                  kullanıcı bunun sistemin ısrarı mı yoksa kendi müdahalesi mi olduğunu bilmeli. */}
              <Kv
                label="Deneme"
                value={`${row.transmissionAttempts ?? 0} otomatik · ${row.manualAttempts ?? 0} manuel`}
              />
              <Kv label="Son deneme" value={fmtDateTime(row.lastAttemptAt)} />

              {/* SERVİS hatası (eksen 1) — bağlantı/timeout. Belge kusursuz olabilir. */}
              {row.lastErrorMessage && (
                <>
                  <div className="edoc-card-label" style={{ marginTop: 10 }}>Servis Hatası</div>
                  <pre className="edoc-raw">{row.lastErrorMessage}</pre>
                </>
              )}

              {/* HAM GİB YANITI — İŞ KURALI 11: ASLA SİLİNMEZ, hata ayıklamanın TEK dayanağı.
                  KOPYALANABİLİR: kullanıcı bunu muhasebeye/entegratöre aynen iletebilmeli. */}
              {row.gibResponseRaw && (
                <>
                  <div className="edoc-card-label" style={{ marginTop: 10 }}>
                    Ham Yanıt
                    <button
                      type="button"
                      className="edoc-copy"
                      onClick={() => {
                        navigator.clipboard?.writeText(row.gibResponseRaw);
                        showToast?.('success', 'Ham yanıt kopyalandı');
                      }}
                    >
                      Kopyala
                    </button>
                  </div>
                  <pre className="edoc-raw edoc-raw--danger">{row.gibResponseRaw}</pre>
                </>
              )}

              {/* ══ EKRANIN EN DEĞERLİ AYRIMI (spec §2) ══════════════════════════════════
                  İkisi de "gönderilemedi" gibi görünür, ama çözümleri ZITTIR. */}
              {row.gibStatus === GIB.ENVELOPE_ERROR && (
                <div className="edoc-warnbox">
                  Bu bir <strong>belge hatası</strong>, servis hatası değil. Belge içeriği
                  düzeltilmeden tekrar gönderim <strong>aynı sonucu verir</strong>. Çözen: muhasebe.
                </div>
              )}
              {row.transmissionStatus === TRANSMISSION.FAILED
                && row.gibStatus !== GIB.ENVELOPE_ERROR && (
                <div className="edoc-infobox">
                  Bu bir <strong>servis hatası</strong> — entegratöre ulaşılamadı. Belge kusursuz
                  olabilir; <strong>Tekrar Gönder</strong> çözebilir. Çözen: BİT.
                </div>
              )}

              {/* e-ARŞİV ZARFLA GİTMEZ — GÜNLÜK RAPORLA GİDER (iş kuralı 5). "Gönderildi" yetmez. */}
              {isApplicable('archiveReport', row.documentType, row.scenario) && (
                <>
                  <div className="edoc-card-label" style={{ marginTop: 10 }}>Günlük Rapor (e-Arşiv)</div>
                  <Kv
                    label="Rapor durumu"
                    value={row.archiveReportStatus === ARCHIVE_REPORT.REPORTED
                      ? <StatusBadge tone="ok">Rapora girdi</StatusBadge>
                      : <StatusBadge tone="wait">Rapora girmedi</StatusBadge>}
                  />
                  <Kv label="Rapor tarihi" value={fmtDateTime(row.archiveReportedAt)} />
                  <div className="edoc-hint">
                    e-Arşiv belgesi GİB'e zarfla değil <strong>günlük raporla</strong> gider.
                    Müşteriye ulaşmış olması, rapora girdiği anlamına gelmez.
                  </div>
                </>
              )}
            </div>

            {/* ── 4. YANIT BLOĞU — YALNIZ TİCARİ e-FATURA + e-İRSALİYE (iş kuralı 4) ────── */}
            <div className={`edoc-card ${!expectsResponse(row.documentType, row.scenario) ? 'edoc-card--dim' : ''}`}>
              <div className="edoc-card-label">Karşı Taraf Yanıtı</div>

              {!expectsResponse(row.documentType, row.scenario) ? (
                // UYGULANAMAZ — ve bunu AÇIKÇA SÖYLÜYORUZ. Boş bırakmak, kullanıcıya "yanıt henüz
                // gelmedi" dedirtir; oysa bu belgede yanıt DİYE BİR ŞEY YOKTUR ve hiç olmayacaktır.
                <p className="edoc-muted" style={{ margin: 0, lineHeight: 1.6 }}>
                  {row.documentType === 2
                    ? 'e-Arşiv belgesidir; alıcı mükellef değildir. Karşı taraf yanıtı '
                    : 'Temel senaryo faturasıdır. Karşı taraf yanıtı '}
                  <strong>uygulanamaz</strong> — bu belge için hiçbir zaman "yanıt bekleniyor"
                  durumu oluşmaz.
                </p>
              ) : (
                <>
                  <Kv
                    label="Durum"
                    value={row.responseStatus === RESPONSE.AWAITING
                      ? <StatusBadge tone="wait">Yanıt bekleniyor</StatusBadge>
                      : <StatusBadge tone={deriveOverallStatus(row).tone}>
                          {(RESPONSE_TEXT[row.responseStatus]) || '—'}
                        </StatusBadge>}
                  />

                  {/* 8 GÜNLÜK SAYAÇ — bilgi "bekleniyor" değil, KAÇ GÜN KALDIĞIDIR (spec §4). */}
                  {row.responseDeadlineAt && (
                    <>
                      <Kv label="Süre bitişi" value={fmtDateTime(row.responseDeadlineAt)} />
                      <Kv
                        label="Kalan"
                        value={<span className={`edoc-remaining edoc-remaining--${remaining.tone}`}>
                          {remaining.label}
                        </span>}
                      />
                    </>
                  )}

                  {row.responseAt && <Kv label="Yanıt tarihi" value={fmtDateTime(row.responseAt)} />}
                  {row.responseReason && <Kv label="Gerekçe" value={row.responseReason} />}

                  {/* KISMİ KABUL — MİKTAR TAŞIR (iş kuralı 6). e-Faturanın ikili kabul/ret'i DEĞİL:
                      alıcı 100 koliden 80'ini kabul edip 20'sini reddedebilir. */}
                  {row.responseStatus === RESPONSE.PARTIALLY_ACCEPTED
                    && detail.responseLines?.length > 0 && (
                    <>
                      <div className="edoc-card-label" style={{ marginTop: 10 }}>Miktar Kırılımı</div>
                      <table className="edoc-lines">
                        <thead>
                          <tr>
                            <th>Ürün</th>
                            <th className="num">Gönd.</th>
                            <th className="num">Kabul</th>
                            <th className="num">Ret</th>
                          </tr>
                        </thead>
                        <tbody>
                          {detail.responseLines.map((l) => (
                            <tr key={l.id}>
                              <td>{l.productName || l.productCode || '—'}</td>
                              <td className="num">{l.sentQuantity}</td>
                              <td className="num">{l.acceptedQuantity}</td>
                              <td className={`num ${l.rejectedQuantity > 0 ? 'edoc-danger' : 'edoc-na'}`}>
                                {l.rejectedQuantity}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      <div className="edoc-warnbox">
                        <strong>Açık soru:</strong> reddedilen miktar plasiyerin stoğuna otomatik geri
                        dönmüyor. Stok düzeltmesi bugün YAPILMIYOR — yalnız kayıt tutuluyor.
                      </div>
                    </>
                  )}

                  {row.responseStatus === RESPONSE.AWAITING && remaining.applicable && !remaining.expired && (
                    <div className="edoc-infobox">
                      Süre dolarsa fatura <strong>otomatik kabul edilmiş sayılır</strong>.
                      Aksiyon bizde değil — satış yöneticisi müşteriyi aramalı.
                    </div>
                  )}
                </>
              )}
            </div>

            {/* ── 5. AKSİYONLAR — DURUMA GÖRE AKTİFLEŞİR (spec §6.6) ───────────────────── */}
            {/* Örnek ekranda 11 buton vardı ve çoğu HER ZAMAN aktifti. Burada soluk bir buton,
                "bu durumda yapılamaz" demenin en dürüst yoludur: tıklatıp sonra hata göstermekten iyidir. */}
            <div className="edoc-actions">
              <ActionBtn
                primary
                disabled={busy || !actions.canResend}
                onClick={() => post('resend', 'Belge kuyruğa alındı')}
                title={actions.canResend
                  ? (needsResendWarning(row)
                    ? 'UYARI: belge içeriği düzeltilmediyse aynı hatayı verecektir'
                    : 'Belgeyi gönderim kuyruğuna al')
                  : 'Yalnız servis hatası veya zarf hatası olan belgeler tekrar gönderilebilir'}
              >
                Tekrar Gönder
              </ActionBtn>

              <ActionBtn
                disabled={busy || !actions.canQueryGib}
                onClick={() => post('query-gib', 'GİB durumu güncellendi')}
                title={actions.canQueryGib
                  ? 'GİB’den güncel zarf durumunu çek'
                  : 'Zarf yalnız gönderilmiş belgede oluşur'}
              >
                GİB'e Sorgula
              </ActionBtn>

              <ActionBtn
                disabled={!actions.canViewResponse}
                onClick={() => showToast?.('info', 'Yanıt detayı yukarıdaki "Karşı Taraf Yanıtı" bloğunda.')}
                title={actions.canViewResponse ? 'Yanıt detayı' : 'Henüz yanıt gelmedi'}
              >
                Yanıt Görüntüle
              </ActionBtn>

              <ActionBtn
                onClick={() => window.open(sourceRoute(row), '_blank', 'noopener')}
                title="Kaynak belgeyi aç (PDF / detay)"
              >
                Belgeyi Görüntüle
              </ActionBtn>

              <ActionBtn
                disabled={!actions.hasEnvelope}
                onClick={() => window.open(`${API_BASE}/${row.id}/envelope`, '_blank', 'noopener')}
                title={actions.hasEnvelope ? 'Zarf XML’ini indir' : 'Zarf henüz oluşmadı'}
              >
                Zarf XML
              </ActionBtn>

              <ActionBtn
                disabled={busy || !actions.canCancel}
                onClick={() => post('cancel', 'Belge iptal edildi')}
                title={actions.canCancel
                  ? 'Belgeyi gönderim hattından çıkar'
                  : 'Gönderilmiş belge iptal edilemez — düzeltme iade faturasıyla yapılır'}
              >
                İptal Et
              </ActionBtn>
            </div>
          </>
        )}
      </div>
    </aside>
  );
}

const RESPONSE_TEXT = {
  [RESPONSE.ACCEPTED]: 'Kabul edildi',
  [RESPONSE.REJECTED]: 'Reddedildi',
  [RESPONSE.PARTIALLY_ACCEPTED]: 'Kısmi kabul',
  [RESPONSE.AUTO_ACCEPTED_TIMEOUT]: 'Süre doldu · otomatik kabul',
  [RESPONSE.AWAITING]: 'Yanıt bekleniyor',
  [RESPONSE.NOT_APPLICABLE]: 'Uygulanamaz',
};

/** Kaynak belgenin detay rotası — e-belge satırı GİB DURUMUNU taşır, belge İÇERİĞİNİ değil. */
function sourceRoute(row) {
  if (row.sourceType === 3) return `/waybills/${row.sourceId}`;
  if (row.sourceType === 4) return '/vehicle-transfers';
  return `/invoices/${row.sourceId}`;
}

function Kv({ label, value }) {
  return (
    <div className="edoc-kv">
      <span>{label}</span>
      <span>{value}</span>
    </div>
  );
}

/** Zaman çizelgesi adımı. Başarısız adım KIRMIZI ve hata mesajını TAŞIR. */
function Timeline({ ev }) {
  const failed = isFailureEvent(ev);
  return (
    <div className={`edoc-tl ${failed ? 'edoc-tl--bad' : 'edoc-tl--ok'}`}>
      <span className="edoc-tl-dot">{failed ? '▲' : '●'}</span>
      <div style={{ minWidth: 0 }}>
        <div className={failed ? 'edoc-danger' : undefined}>
          {ev.message || EVENT_AXIS_LABEL[ev.axis] || 'Olay'}
        </div>
        <div className="edoc-tl-meta">
          {fmtDateTime(ev.occurredAt)}
          {ev.axis != null && ` · ${EVENT_AXIS_LABEL[ev.axis]}`}
          {ev.actor === 1 && ' · kullanıcı'}
        </div>
      </div>
    </div>
  );
}

/** Olay bir HATA mı? Eksen bazlı: her eksenin "kötü" değeri farklıdır. */
function isFailureEvent(ev) {
  if (ev.axis === EVENT_AXIS.TRANSMISSION) return ev.toStatus === TRANSMISSION.FAILED;
  if (ev.axis === EVENT_AXIS.GIB) return ev.toStatus === GIB.ENVELOPE_ERROR;
  if (ev.axis === EVENT_AXIS.RESPONSE) return ev.toStatus === RESPONSE.REJECTED;
  return false;
}

function ActionBtn({ children, onClick, disabled, primary, title }) {
  return (
    <button
      type="button"
      className={`edoc-abtn ${primary ? 'edoc-abtn--primary' : ''} ${disabled ? 'edoc-abtn--dis' : ''}`}
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      title={title}
    >
      {children}
    </button>
  );
}

export default EDocumentDrawer;
